// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#paper-canvas[data-v-acf008b0]{background:#1b1b1b}.fill-height[data-v-acf008b0]{flex:1 1 auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
